import React from 'react';
import { motion } from 'framer-motion';

// --- Placeholder Content ---
const bioText = "I'm a full stack developer from Hyderabad, India with a passion for building beautiful, functional, and user-centric web applications. My journey into code began with a fascination for how things work, and it has since evolved into a career where I get to solve complex problems with clean, efficient code.";
const philosophyText = "I believe in the power of simplicity. For me, writing code is a craft that requires precision, clarity, and a deep understanding of the user's needs. I strive to build software that is not only robust and scalable but also intuitive and enjoyable to use.";
const skills = {
  "Frontend": ["React", "Next.js", "JavaScript (ES6+)", "Tailwind CSS", "Framer Motion"],
  "Backend": ["Node.js", "Express", "MongoDB", "REST APIs"],
  "Tools": ["Git & GitHub", "Figma", "Webflow", "VS Code"],
};

// --- Animation Variant ---
const contentBlockVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const About = () => {
  return (
    <section id="about" className="bg-background grainy py-24 sm:py-32 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-16">
        
        {/* Left Sticky Column */}
        <div className="md:col-span-1">
          <div className="sticky top-24">
            <h2 className="font-heading text-4xl font-bold text-text-primary">About Me</h2>
            <hr className="mt-4 mb-6 border-white/10" />
            <p className="font-sans text-text-secondary">
              A brief look into my background, philosophy, and the tools I use to bring ideas to life.
            </p>
          </div>
        </div>

        {/* Right Scrolling Column */}
        <div className="md:col-span-2 space-y-16">
          {/* Bio Section */}
          <motion.div
            variants={contentBlockVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <h3 className="text-2xl font-bold font-heading text-text-primary mb-4">Biography</h3>
            <p className="text-text-secondary leading-relaxed">{bioText}</p>
          </motion.div>

          {/* Philosophy Section */}
          <motion.div
            variants={contentBlockVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <h3 className="text-2xl font-bold font-heading text-text-primary mb-4">My Philosophy</h3>
            <p className="text-text-secondary leading-relaxed">{philosophyText}</p>
          </motion.div>

          {/* Skills Section */}
          <motion.div
            variants={contentBlockVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <h3 className="text-2xl font-bold font-heading text-text-primary mb-4">Core Technologies</h3>
            <div className="space-y-6">
              {Object.entries(skills).map(([category, items]) => (
                <div key={category}>
                  <h4 className="font-bold text-text-primary mb-2">{category}</h4>
                  <div className="flex flex-wrap gap-2">
                    {items.map((item) => (
                      <span key={item} className="bg-primary text-text-secondary text-sm font-medium px-3 py-1 rounded-full">
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;